import { INotification, Notification } from "../../Notification";

export interface IUpdateNotificationRequest {
    notification: INotification;
}

export class UpdateNotificationRequest implements IUpdateNotificationRequest {
    /**
     *
     */
    constructor(notification: INotification) {
        this.notification = notification;
    }
    public notification: INotification = new Notification();
}